export const getEncodedUrlByKey = (
  search: string,
  key: string
): string | null => {
  return search.slice(search.indexOf(key) + key.length + 1);
};
